class AddTimeController {

    constructor(onAddTimeFn) {
        this.view = new AddTimeView(
            this.onChangeSelection.bind(this),
            this.onValidate.bind(this),
            function(){
                onAddTimeFn(this.scheduleType, this.otherInput);
            }.bind(this));
    }

    show() {
        this.view.show();
    }

    onChangeSelection(e) {
        let clicked = $(e.target);
        if(!clicked.hasClass('dropdown-item')) {
            clicked = clicked.parents('.dropdown-item');
        }
        this.scheduleType = parseInt(clicked.parent().attr('data-schedule-type'));
        let indicator = clicked.find('.color-indicator');
        let time = clicked.find('.time');
        this.view.dropdownToggle.empty();
        this.view.dropdownToggle.append(indicator.clone());
        this.view.dropdownToggle.append(time.clone());

        this.view.otherActivityNameDiv.showAnimatedIf(this.scheduleType === ScheduleType.other);

        this.onValidate();
    }

    onValidate() {
        this.otherInput = this.view.otherActivityNameInput.valueTrimmed();

        let valid = this.scheduleType !== ScheduleType.other || fieldIsNotEmpty(this.otherInput);

        this.view.doneButton.enableIf(valid);
    }
}
